import type { RouteObject } from "react-router-dom";
import { PagesControlcenterApp } from "./PagesControlcenterApp";
import { ControlCenterIncompletePath } from "./components/ControlCenterIncompletePath";
import type { environments } from "@dealer-center/core-enviroment";
import { IncentivesManagerWrapper } from "@dealer-center/ddc-pages-incentives-manager-react";
import { InventoryManagerWrapper } from "@dealer-center/ddc-pages-inventory-manager-react";
import { AccountAssets } from "@dealer-center/ddc-pages-accountassets-react";
import { Welcome, YourTeam } from "@dealer-center/ddc-pages-welcome-react";
import { DdcFeeManager } from "@dealer-center/ddc-pages-fee-manager-react";

export const PagesControlcenterUiRoutes: RouteObject[] = [
  {
    element: <PagesControlcenterApp />,
    children: [
      {
        index: true,
        element: <ControlCenterIncompletePath />
      },
      {
        path: "incentivesManager",
        element: <IncentivesManagerWrapper />
      },
      {
        path: "inventoryManager",
        element: <InventoryManagerWrapper />
      },
      {
        path: "accountAssets",
        element: <AccountAssets />
      },
      {
        path: "feemanager",
        element: <DdcFeeManager />
      },
      {
        path: "welcome",
        children: [
          {
            index: true,
            element: <Welcome />
          },
          {
            path: "yourteam",
            element: <YourTeam />
          }
        ]
      }
    ]
  }
];

export const getControlCenterRoutes = (
  environment: environments,
  auth: React.ReactElement
) => {
  const asPaths = [
    {
      path: "/cc",
      element: auth,
      children: PagesControlcenterUiRoutes
    },
    {
      path: "/cc/as/:asAccount/:asUser",
      element: auth,
      children: PagesControlcenterUiRoutes
    }
  ];
  if (environment === "local" || environment === "qa") {
    return asPaths;
  } else {
    return asPaths;
  }
};
